import * as React from "react";
import {CSSProperties, useContext} from "react";
import {getRecentlyVisitedUnits, Product} from "@consts/common";
import {UnitContext} from "../App";
import {sortArray} from "@intuitionrobotics/ts-common";
import Select, {StylesConfig} from "react-select";
import {ActivationsModule} from "@modules/ActivationsModule";

type Props = {
    product?: Product
    unitId?: string
    onUnitSelected: (value: string) => void,
    style?: CSSProperties,
    placeholder?: string
    regexFilter?: RegExp
    styles?: StylesConfig<{ value: string, label: string }, false>
}
export const RenderSelectUnit = ({product, unitId, onUnitSelected, style, placeholder = "Select unit", regexFilter, styles}: Props) => {
    if (!product)
        return;

    const {activatedUnits} = useContext(UnitContext);

    const units = Array.from(activatedUnits);
    if (!units.length)
        return;

    const recentlyVisited = getRecentlyVisitedUnits();
    const allOptions = sortArray(units.map(_unitId => ({value: _unitId, label: _unitId})), unit => unit.value, true);
    const recentOptions = recentlyVisited.filter(id => units.includes(id)).map(id => ({value: id, label: id}));
    const restOptions = allOptions.filter(o => !recentlyVisited.includes(o.value));
    const options = [...recentOptions, ...restOptions];
    // Match by unit id OR by device serial (som/tablet from the unit's
    // activation) — typing a serial finds its unit.
    const filterOption = (option: { value: string }, rawInput: string) => {
        const q = rawInput.trim().toLowerCase();
        if (!q)
            return true;
        if (option.value.toLowerCase().includes(q))
            return true;
        const activation = ActivationsModule.getActivation(option.value);
        if (!activation)
            return false;
        return [activation.som_device_id, activation.tablet_device_id]
            .some(serial => !!serial && serial.toLowerCase().includes(q));
    };

    return <div style={{minWidth: 150, ...style}}><Select
        styles={styles}
        value={unitId ? {value: unitId, label: unitId} : undefined}
        options={options.filter((o) => {
            if (!regexFilter)
                return true;
            return regexFilter.test(o.value);
        })}
        filterOption={filterOption}
        placeholder={placeholder}
        onChange={(v) => v && onUnitSelected(v.value)}
    /></div>
};
